import auth from './api/auth';
import staff from './api/staff';
import group from './api/group';
import admin from './api/admin';
import restaurant from './api/restaurant';
import publicApi from './api/public-api';
import gyb from './api/gyb';
import firstMenu from './api/first-menu';
import service from './api/service';
import secondMenu from './api/second-menu';
import rule from './api/rule';
import dish from './api/dish';
import taxGroup from './api/tax-group';
import condimentGroup from './api/condiment-group';
import dishIconDescription from './api/dish-icon-description';
import setting from './api/setting';
import dataAnalysis from './api/data-analysis';
import warrant from './api/warrant';
import dishBook from './api/dish-book';
import core from './api/core';
import coreFileLog from './api/core-file-log';
import dataAnalysisSw2p5 from './api/data-analysis-sw2p5';
import authGroupController from './api/auth-group-controller';
import groupWarrant from './api/group-warrant';
import sensitiveRecord from './api/sensitive-record';
import menuApi from './api/rbp/menu';
import paymentApi from './api/rbp/payment';
import printSettingApi from './api/rbp/print-setting';
import priceSpecificationApi from './api/rbp/price-specification';
import condimentsApi from './api/rbp/condiment';
import dishLabelApi from './api/rbp/dish-label';
import RBPRestautantApi from './api/rbp/rbp-restaurant';
import reserveApi from './api/rbp/reserve';
import settingApiRBP from './api/rbp/setting-rbp';
import disRbpApi from './api/rbp/dis-rbp';
import dishSoldOutApi from './api/rbp/dish-sold-out';
import cloudDishLibraryApi from './api/rbp/cloud-dish-library';
import quickOrderRemarksApi from './api/rbp/quick-order-remarks';
import loginApi from './api/log';
import restoreApi from './api/restore';
import reseller from './api/reseller';
import resellerConsumption from './api/reseller-consumption';
import deliverectApi from './api/deliverect';
import risk from './api/risk';
import groupRevenueAnalysisApi from './api/group-revenue-analysis'
import sharkApi from './api/shark';
import menuStoreApi from './api/menu-store';
import restaurantStaticApi from './api/restaurant-static';
import anagraficaOcrApi from './api/anagrafica-ocr';
import employeeClassApi from './api/rbp/employee-class';
import employeeApi from './api/rbp/employee';

// 接口统一暴露
const apiManage = {
    ...auth,
    ...staff,
    ...group,
    ...admin,
    ...restaurant,
    ...publicApi,
    ...gyb,
    ...firstMenu,
    ...secondMenu,
    ...rule,
    ...service,
    ...dish,
    ...taxGroup,
    ...condimentGroup,
    ...dishIconDescription,
    ...setting,
    ...dataAnalysis,
    ...warrant,
    ...dishBook,
    ...core,
    ...coreFileLog,
    ...dataAnalysisSw2p5,
    ...authGroupController,
    ...groupWarrant,
    ...sensitiveRecord,
    ...loginApi,
    ...restoreApi,
    ...reseller,
    ...resellerConsumption,
    ...deliverectApi,
    ...risk,
    ...groupRevenueAnalysisApi,
    ...sharkApi,
    ...menuStoreApi,
    ...restaurantStaticApi,
    ...anagraficaOcrApi,
}

export const apiManage_rbp = {
    ...menuApi,
    ...paymentApi,
    ...printSettingApi,
    ...priceSpecificationApi,
    ...setting,
    ...condimentsApi,
    ...dishLabelApi,
    ...RBPRestautantApi,
    ...reserveApi,
    ...settingApiRBP,
    ...disRbpApi,
    ...dishSoldOutApi,
    ...cloudDishLibraryApi,
    ...quickOrderRemarksApi,
    ...employeeClassApi,
    ...employeeApi,
}

export default apiManage;